// extracted by mini-css-extract-plugin
module.exports = {"name":"Item_name__3zGZZ","cellCenter":"Item_cellCenter__1fOOu","removeCell":"Item_removeCell__2qBoM","icon":"Item_icon__2qRuY","actions":"Item_actions__1P0pQ"};